// Wait for the image to appear in the DOM, then observe its attributes
const imageId = "customerSwagImg";
const config = { attributes: true, childList: true, subtree: true };

function setDimensions(img, observer) {
    img.height = img.naturalHeight;
    img.width = img.naturalWidth;
    observer.disconnect();
}

function setupImageObserver(img) {
    const attrObserver = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "attributes") {
                setDimensions(img, observer);
            }
        }
    });
    attrObserver.observe(img, { attributes: true });
    // In case the image is already loade
    if (img.complete) {
        setDimensions(img, attrObserver);
    }
}

const parentObserver = new MutationObserver((mutationList, observer) => {
    const img = document.getElementById(imageId);
    if (img) {
        setupImageObserver(img);
        observer.disconnect();
    }
});

// If image is already present, set up immediately; otherwise, observe body for additions
const existingImg = document.getElementById(imageId);
if (existingImg) {
    setupImageObserver(existingImg);
} else {
    parentObserver.observe(document.body, { childList: true, subtree: true });
}